import Api from "../../service";
import REQUEST_URLS from "../../defaults/requestUrl";

async function CreateProcess(token,data){
    return await Api.post(REQUEST_URLS.COMPANY_APPROVAL.CREATE_PROCESS,data,{
        headers:{
            "Authorization": `Bearer ${token}`
        }
    });
}
export default CreateProcess;